var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaestro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1583 2.13855H20.8882V17.8623H12.1583V2.13855Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7129 10.0001C12.7117 8.48551 13.0545 6.99053 13.7151 5.62837C14.3757 4.26621 15.3369 3.07258 16.5259 2.13787C15.0542 0.978382 13.2866 0.25732 11.4252 0.0571007C9.56392 -0.143118 7.68394 0.185585 6.00018 1.00564C4.31643 1.8257 2.89683 3.10402 1.90366 4.69449C0.910478 6.28497 0.383789 8.12343 0.383789 9.99974C0.383789 11.8761 0.910478 13.7145 1.90366 15.305C2.89683 16.8955 4.31643 18.1738 6.00018 18.9938C7.68394 19.8139 9.56392 20.1426 11.4252 19.9424C13.2866 19.7422 15.0542 19.0211 16.5259 17.8616C15.337 16.927 14.3759 15.7335 13.7152 14.3714C13.0546 13.0094 12.7118 11.5145 12.7129 10.0001Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6652 10.0001C32.6652 11.8764 32.1385 13.7149 31.1454 15.3054C30.1523 16.8959 28.7327 18.1742 27.049 18.9943C25.3652 19.8144 23.4853 20.1431 21.6239 19.943C19.7626 19.7428 17.995 19.0218 16.5232 17.8623C17.7107 16.9265 18.6707 15.7326 19.3308 14.3707C19.9909 13.0088 20.3339 11.5145 20.3339 10.0004C20.3339 8.48636 19.9909 6.99204 19.3308 5.63017C18.6707 4.2683 17.7107 3.07442 16.5232 2.13857C17.995 0.979158 19.7625 0.258148 21.6238 0.0579483C23.485 -0.142252 25.3649 0.186435 27.0487 1.00644C28.7324 1.82645 30.1519 3.1047 31.1451 4.69509C32.1383 6.28548 32.6651 8.12386 32.6652 10.0001Z",
    fill: "#00A1DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/maestro.6d2d38457db079a4eff5744d45ddd79a.svg";
export { ForwardRef as ReactComponent };